import deviceWidth from './deviceWidth';
import px from './px';

const pt = num => {
    if (num === 1) {
        return px(2);
    }

    return Math.floor(num * deviceWidth / 750);
};

export default pt;
